import { render } from "./suppliers.vue?vue&type=template&id=2920a033"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"

import "./suppliers.vue?vue&type=style&index=0&id=2920a033&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__